/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutRegionController', function ($scope, $q, $element, CommonUtils) {

            $scope.Step = 'Checkout';
            $scope.Config = {};

            $scope.StepNumber = 1;
            $scope.LastStepNumber = 2;

            $scope.BillingAsShipping = $element.data('billingasshippingdefaultvalue');
            $scope.EnableCreateAccount = $element.data('enablecreateaccount');
            $scope.Config.ShippingView = $element.data('shippingview');
            $scope.Config.BillingView = $element.data('billingview');
            $scope.ShippingAddresses = [];
            $scope.BillingAddresses = [];

            angular.element(".checkout-default-region").ready(function () {
                if ($(".checkout-loading").length > 0) {
                    $(".checkout-loading").hide();
                    /* Track Initiate Checkout */
                    if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                        if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                            fbq('track', 'InitiateCheckout');
                        }
                    }
                    /* END Track Initiate Checkout */
                }
            });  

            if (checkoutOverrides && checkoutOverrides.Parent && typeof checkoutOverrides.Parent.Extend === 'function'){
                $scope = checkoutOverrides.Parent.Extend($scope);
            }

            $scope.TermsInitialyValidated = false; 
            $scope.Locked = false;

            $scope.IsCanceled = LhApp.Function.QueryString.getValueOf('mode').toLowerCase() === 'canceled';
            $scope.IsRetrying = LhApp.Function.QueryString.getValueOf('mode').toLowerCase() === 'retry';
            $scope.IsRetryingInCorrectStock = LhApp.Function.QueryString.getValueOf('mode').toLowerCase() === 'retryincorrectstock';
            $scope.IsFailed = false;
            $scope.IsPermissionAllowed = true;


            if ($scope.IsRetrying && LhApp.Function.QueryString.getValueOf('externalapi').toLowerCase() === 'error') {
                $scope.IsExternalApiError = true;
            } else if ($scope.IsRetrying && LhApp.Function.QueryString.getValueOf('externalDigitalCareError').toLowerCase() === 'true') {
                $scope.IsExternalDigitalCareError = true;
            } else if ($scope.IsRetrying && LhApp.Function.QueryString.getValueOf('messages')) {
                $scope.IsRetryingMessagesError = true;
                var messages = decodeURIComponent(LhApp.Function.QueryString.getValueOf('messages').replace(/\+/g, ' '));
                try {
                    $scope.ErrorMessages = JSON.parse(messages);
                }
                catch(e){
                    $scope.ErrorMessages = [messages];
                }
            }

            //its not generic retrying when ther is specific
            $scope.IsRetrying = $scope.IsRetrying && !($scope.IsExternalApiError || $scope.IsExternalDigitalCareError || $scope.IsRetryingMessagesError);

            var controls = [];
            $scope.registerControl = function (name, control) {
                if ($scope[name] === undefined) {
                    $scope[name] = {
                        Wrapper: control,
                        Current: undefined
                    };
                    controls.push(control);
                }
            };

            $scope.setControlValue = function (name, value) {
                if ($scope[name] === undefined)
                    throw new Error(name + ' is not registered as a control on the shared $scope');

                $scope[name].Current = value;
            };
            
            var validateStep = function (step, onComplete) {

                var validateControl = function (control) {
                    var validation = $q.defer();
                    if (typeof (control.validate) === 'function') {
                        control.validate(function(result) {
                            validation.resolve(result);
                        });
                    }
                    else {
                        validation.resolve(true);
                    }

                    return validation.promise;
                };

                var valid = true;
                var firstInvalidControl = undefined;
                var isAnyControlLoading =
                    $('.x-checkoutshippingmethod').scope().Control.Loading ||
                    $('.x-checkoutbillingaddress').scope().Control.Loading ||
                    $('.x-checkoutshippingaddress').scope().Control.Loading ||
                    $('.x-checkoutpaymentmethod').scope().Control.Loading;

                valid = !isAnyControlLoading;

                var $postCode = $('.x-checkoutshippingaddress input[type="text"][ng-model="Control.Form.PostCode"]', $element);
                var $area = $('.x-checkoutshippingaddress input[type="text"][ng-model="Control.Form.Area"]', $element);
                var $countries = $('.x-checkoutshippingaddress select[ng-model="Control.Form.Country"]', $element);
                var shScope = angular.element('.x-control.x-angular-control.x-checkoutshippingaddress').scope();
                var dpScope = angular.element('.x-control.x-angular-control.x-checkoutdeliverypoint').scope();
                var $shippingAreaAutocomplete = $('.x-control.x-angular-control.x-checkoutshippingaddress', $element);
                var $billingAreaAutocomplete = $('.x-control.x-angular-control.x-checkoutbillingaddress', $element);

                if (valid && shScope.Control.IsOpen && dpScope.Control.Selected.Code === 'onSite' && !shScope.Model.Data.Config.IsAreaAutofill && !validateArea($postCode, $area, $countries) && $shippingAreaAutocomplete.data('areaautocomplete')) {
                    shScope.Control.Form.AreaError = true;
                    shScope.Control.Form.AreaRequired = true;
                    shScope.Control.Form.Area = '';
                    valid = false;
                }
                
                $postCode = $('.x-checkoutbillingaddress input[type="text"][ng-model="Control.Form.PostCode"]', $element);
                $area = $('.x-checkoutbillingaddress input[type="text"][ng-model="Control.Form.Area"]', $element);
                $countries = $('.x-checkoutbillingaddress select[ng-model="Control.Form.Country"]', $element);
                var biScope = angular.element('.x-control.x-angular-control.x-checkoutbillingaddress').scope();

                if (valid && (!biScope.BillingAsShipping || dpScope.Control.Selected.Code === 'fromStore') && !biScope.Model.Data.Config.IsAreaAutofill && !validateArea($postCode, $area, $countries) && $billingAreaAutocomplete.data('areaautocomplete')) {
                    biScope.Control.Form.AreaError = true;
                    biScope.Control.Form.AreaRequired = true;
                    biScope.Control.Form.Area = '';
                    valid = false;
                }             

                var stepControls = [];
                var returnedControls = [];
                $(controls).each(function (c, control) {
                    if ($(control).data('step') === step) {
                        stepControls.push(control);
                    }
                });

                $(stepControls).each(function (c, control) {
                    var promise = validateControl(control);
                    promise.then(function (response) {
                        if (!response) {
                            if (firstInvalidControl === undefined)
                                firstInvalidControl = control;

                            valid = false;
                        }

                        returnedControls.push(c);
                        
                        if (returnedControls.length === stepControls.length) {
                            setTimeout(function () {
                                if (!valid && firstInvalidControl !== undefined) {

                                    $scope.scrollTo({
                                        el: firstInvalidControl,
                                        offset: $(firstInvalidControl).data('offset') || 0,
                                        timeout: 200
                                    });
                                }
                            }, 300);

                            if (typeof (onComplete) === 'function') {
                                setTimeout(function () {
                                    onComplete(valid);
                                }, 500);
                            }
                        }
                    }, function (error) {
                        throw error;
                    });
                });
            };

            var retryOrder = function() {
                $scope.IsFailed = true;
                $scope.Locked = false;
                $scope.StepNumber = 1;
                $scope.$apply();

                var elem = $('*[data-message="exception"]', $element);
                if (elem.length > 0) {
                    $scope.scrollTo({
                        el: elem.get(0),
                        offset: -40,
                        timeout: 200
                    });
                }
            };

            var completeOrder = function () {
                var processUrl = $($scope.Order.Wrapper).data('processurl');

                var deliveryPoint = $scope.Order.Current.DeliveryPoint.Id;
                var store = $scope.Order.Current.Store.Id;
                var shippingAddress = CommonUtils.clone($scope.Order.Current.Shipping);
                var billingAddress = CommonUtils.clone($scope.Order.Current.Billing);
                if ($scope.BillingAsShipping && $scope.Config.IsShippingEnabled && $scope.Order.Current.DeliveryPoint.Code.indexOf("onSite") > -1)
                    billingAddress = CommonUtils.clone(shippingAddress);
                var shippingMethod = CommonUtils.clone($scope.Order.Current.ShippingMethod);
                var paymentMethod = CommonUtils.clone($scope.Order.Current.PaymentMethod);
                var orderType = CommonUtils.clone($scope.Order.Current.OrderType);

                var form = $('<form />')
                    .prop('method', 'POST')
                    .prop('action', (LhApp.Context.Request.IsSecure ? 'https' : 'http') + '://' + LhApp.Context.Request.Domain + processUrl)
                    .append(
                        $('<input />')
                            .prop('type', 'hidden')
                            .prop('name', 'orderId')
                            .val($scope.Order.Current.MainOrderId || $scope.Order.Current.OrderId)
                    )
                        .append(
                        $('<input />')
                            .prop('type', 'hidden')
                            .prop('name', 'store')
                            .val(store)
                    )
                        .append(
                        $('<input />')
                            .prop('type', 'hidden')
                            .prop('name', 'deliveryPoint')
                            .val(deliveryPoint)
                    )
                    .append(
                        $('<input />')
                            .prop('type', 'hidden')
                            .prop('name', 'shippingMethod')
                            .val(JSON.stringify(shippingMethod))
                    ).append(
                        $('<input />')
                            .prop('type', 'hidden')
                            .prop('name', 'paymentMethod')
                            .val(JSON.stringify(paymentMethod))
                    ).append(
                        $('<input />')
                            .prop('type', 'hidden')
                            .prop('name', 'orderType')
                            .val(JSON.stringify(orderType))
                    );

                $('body').append(form);
                form.get(0).submit();
            };

            var insertTermsOfUseConsent = function () {
                var url = document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/services/api/Consents/InsertConsents';

                var data = [{ type: 'TermsOfUse', source: 'Checkout', approved: true }];
                var disclaimerScope = angular.element('.x-control.x-angular-control.x-checkoutdisclaimer').scope();
                if (disclaimerScope && !disclaimerScope.Model.Data.IsPrivacyPolicyDedicatedPageEnabled)
                    data[data.length] = { type: 'PrivacyPolicy', source: 'Checkout', approved: true };

                $.ajax({
                    type: "POST",
                    url: url,
                    data: JSON.stringify(data),
                    dataType: 'json',
                    contentType: 'application/json; charset=UTF-8',
                    ContentType: 'application/json; charset=UTF-8',
                    success: completeOrder,
                    failure: retryOrder,
                    error: retryOrder
                });
            };

            var proceedCheckout = function () {
                var isGuestCheckoutEnabled = $($scope.Order.Wrapper).data('guestcheckout');
                var loginUrl = $($scope.Order.Wrapper).data('loginurl');
                var testValue = $('#inputTestOrder').val();

                /* Track Payment Page */
                if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                    if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                        if ($scope['Order'].Current.PaymentMethod.Code == 'creditCard') {
                            fbq('trackCustom', 'PaymentPage');
                        }
                    }
                }         
                /* END Track Payment Page */

                $scope.Order.Wrapper.submit(testValue).then(function (response) {
                    $scope.customUserErrorMessage = false;

                    if (response.Success) {
                        if (!LhApp.Context.IsConsentsEnabled) {
                            completeOrder();
                        } else {
                            insertTermsOfUseConsent();
                        }
                        $scope.Order.Current.HasError = 0;
                        $scope.Order.Current.Errors = [];
                    } else {
                        var customUserErrorMessagesResponseCodes = ['OrderSubmit_InvalidAsDifferentEntityCodes'];

                        $scope.Order.Current.HasError = 1;

                        var data = JSON.parse(response.Data);

                        if (data && data.Message) {
                            $scope.Order.Current.Errors = data.Message;

                            if ($scope.Order.Current.Errors) {
                                $scope.OrderCheckoutErrors = $scope.Order.Current.Errors
                            } else {
                                $scope.OrderCheckoutErrors = [$scope.Order.Texts.Checkout_OrderFailedMessage];
                            }
                        } else {
                            $scope.OrderCheckoutErrors = [$scope.Order.Texts.Checkout_OrderFailedMessage];
                        }

                        if (response.Code == 'OrderSubmit_UserNotLoggedIn') {
                            if (isGuestCheckoutEnabled) {
                                $scope.Order.Current.IsLoggedIn = false;
                                validateStep(1, function (valid) {
                                    if (valid && !checkoutConfig.isOneStepCheckout) {
                                        validateStep(2, function (valid2) {
                                            if (valid2) {
                                                $scope.Locked = false;
                                            } else {
                                                $scope.StepNumber = 2;
                                                $scope.Locked = false;
                                            }
                                        });
                                    } else {
                                        $scope.StepNumber = 1;
                                        $scope.Locked = false;
                                    }
                                });
                            } else {
                                document.location = loginUrl;
                            }
                        } else if (response.Code == 'OrderSubmit_PermissionDenied') {
                           
                            $scope.IsPermissionAllowed = $scope.Order.IsPermissionAllowed;
                            $scope.Locked = false;

                            var elem = $('*[data-message="permissionDenied"]', $element);
                            if (elem.length > 0) {
                                $scope.scrollTo({
                                    el: elem.get(0),
                                    offset: -40,
                                    timeout: 200
                                });
                            }
                        } else if (customUserErrorMessagesResponseCodes.includes(response.Code) && response.Data && JSON.parse(response.Data).Message && JSON.parse(response.Data).Message[0]) { // custom user error message case
                            $scope.Locked = false;
                            $scope.customUserErrorMessage = true;

                            var elem = $('*[data-message="customErrorMessage"]', $element);
                            if (elem.length > 0) {
                                var message = JSON.parse(response.Data).Message[0];
                                elem.html(message);

                                $scope.scrollTo({
                                    el: elem.get(0),
                                    offset: -40,
                                    timeout: 200
                                });
                            }
                        } else if (response.Code == 'OrderSubmit_DirtyCartError') {

                            $scope.IsCartDirty = true;
                            $scope.Locked = false;

                            var elem = $('*[data-message="errorDirtyCart"]', $element);
                            if (elem.length > 0) {
                                $scope.scrollTo({
                                    el: elem.get(0),
                                    offset: -40,
                                    timeout: 200
                                });
                            }
                        } else if (response.Code == 'OrderSubmit_InvalidExplicitTimeslot') {
                           
                            $scope.InvalidExplicitTimeslot = true;
                            $scope.Locked = false;

                            if ($scope.Config.IsExplicitTimeslotEnabled)
                                $('.x-control.x-angular-control.x-checkoutorderexplicittimeslot').get(0).reload();

                            var elem = $('*[data-message="errorExplicitTimeslot"]', $element);
                            if (elem.length > 0) {
                                $scope.scrollTo({
                                    el: elem.get(0),
                                    offset: -40,
                                    timeout: 200
                                });
                            }
                        } else if (response.Code == 'OrderSubmit_WebHookResponse') {
                            $scope.InvalidWebHookResponse = true;
                            $scope.Locked = false;

                            var webHookData = JSON.parse(JSON.parse(response.Data));
                            $scope.WebHookErrorCode = webHookData.Code;
                            $scope.WebHookErrorMessage = webHookData.Message;
                            
                            var elem = $('*[data-message="webhook"]', $element);
                            if (elem.length > 0) {
                                $scope.scrollTo({
                                    el: elem.get(0),
                                    offset: -40,
                                    timeout: 200
                                });
                            }
                        } else if (response.Code == 'OrderSubmit_DigitalCare_OTPExpired') {
                            $scope.OTPExpired = true;
                            $scope.Locked = false;

                            var elem = $('*[data-message="errorDigitalCare"]', $element);
                            if (elem.length > 0) {
                                var message = JSON.parse(response.Data).Message[0];
                                elem.html(message);

                                $scope.scrollTo({
                                    el: elem.get(0),
                                    offset: -40,
                                    timeout: 200
                                });
                            }
                        } else {
                            $scope.IsFailed = true;
                            $scope.Locked = false;

                            var elem = $('*[data-message="exception"]', $element);
                            if (elem.length > 0) {
                                $scope.scrollTo({
                                    el: elem.get(0),
                                    offset: -40,
                                    timeout: 200
                                });
                            }
                        }
                        $(".checkout-loading").hide();
                    }
                }, function (error) {
                    $scope.Locked = false;
                    throw error;
                });
            };


            $scope.previous = function () {
                if ($scope.StepNumber == 1) {
                    $scope.Locked = true;
                    document.location = LhApp.Url.Page.CheckoutLogin;
                }
                else {
                    if (checkoutConfig.refreshDeliveryPoint) {
                        angular.element('.x-control.x-angular-control.x-checkoutorder').get(0).reload().then(function () {
                            angular.element('.x-control.x-angular-control.x-checkoutdeliverypoint').get(0).reload();
                        });
                    }
                    $scope.StepNumber--;

                    if ($scope['Disclaimer']) {
                        $scope['Disclaimer'].Current.TermsAccepted = false;
                        $scope['Disclaimer'].Current.TermsAcceptedError = false;
                    }

                    $scope.IsCanceled = false;
                    $scope.IsRetrying = false;
                    $scope.IsRetryingInCorrectStock = false;
                    $scope.IsFailed = false;

                    $scope.scrollTo({
                        el: $('.checkout-steps', $element).get(0),
                        offset: $('.checkout-steps', $element).data('offset') || 0,
                        timeout: 200
                    });
                }
            };

            $scope.next = function () {
                $scope.Locked = true;
                validateStep($scope.StepNumber, function (valid) {

                    if (valid) {

                        $scope.IsCanceled = false;
                        $scope.IsRetrying = false;
                        $scope.IsRetryingInCorrectStock = false;
                        $scope.IsFailed = false;

                        if ($(".checkout-loading").length > 0)
                            $(".checkout-loading").show();

                        if ($scope.StepNumber < $scope.LastStepNumber && !checkoutConfig.isOneStepCheckout) {

                            var stepControlPromises = [];
                            $(controls).each(function (c, control) {
                                if ($(control).data('step') === $scope.StepNumber) {
                                    if ($(control).is(':visible')) {
                                        if (typeof (control.set) === 'function') {
                                            stepControlPromises.push(control.set());
                                        }
                                    }
                                }
                            });
                            
                            var proceed = function () {
                                if (checkoutConfig.refreshDeliveryPoint) {
                                    angular.element('.x-control.x-angular-control.x-checkoutorder').get(0).reload().then(function () {
                                        angular.element('.x-control.x-angular-control.x-checkoutdeliverypoint').get(0).reload();
                                    });
                                }
                                $scope.StepNumber++;
                                $scope.scrollTo({
                                    el: $('.checkout-steps', $element).get(0),
                                    offset: $('.checkout-steps', $element).data('offset') || 0,
                                    timeout: 200
                                });
                                $scope.Locked = false;
                            };

                            $q.all(stepControlPromises).then(function () {
                                if ($scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) == 'function') {
                                    $scope['Order'].Wrapper.reload().then(function (orderResponse) {
                                        var shippingMethods = angular.element('.x-control.x-angular-control.x-checkoutshippingmethod');
                                        if (shippingMethods.length > 0 && typeof (shippingMethods.reload) == 'function') {
                                            angular.element('.x-control.x-angular-control.x-checkoutshippingmethod').reload();
                                        }

                                        proceed();
                                    });
                                }
                                else {
                                    proceed();
                                }
                            }, function (error) {
                                $scope.Locked = false;
                                throw error;
                            });
                        }
                        else {
                            proceedCheckout();
                        }
                    }
                    else {
                        $scope.Locked = false;
                        $scope.$apply();
                    }
                });
            };

            $scope.scrollToCoupon = function () {
                $scope.StepNumber = 1;
                $scope.scrollTo({
                    el: $scope.Coupon.Wrapper,
                    offset: $($scope.Coupon.Wrapper).data('offset') || 0,
                    timeout: 200
                });
            };

            $scope.scrollToGiftWrap = function () {
                $scope.StepNumber = 1;
                $scope.scrollTo({
                    el: $scope.GiftWrap.Wrapper,
                    offset: $($scope.GiftWrap.Wrapper).data('offset') || 0,
                    timeout: 200
                });
            };

            $scope.scrollToStore = function () {
                var $dpScope = angular.element('.x-control.x-angular-control.x-checkoutdeliverypoint').scope();
                $dpScope.Model.Data.DeliveryPoints.forEach(function (dp) {
                    if (dp.Code == 'fromStore') {
                        $dpScope.Control.setSelectedDeliveryPoint(dp);
                    }
                });

                $scope.StepNumber = 1;
                $scope.scrollTo({
                    el: $scope.Store.Wrapper,
                    offset: $($scope.Store.Wrapper).data('offset') || 0,
                    timeout: 200
                });
            };

            $scope.scrollToShippingAddress = function () {
                if ($scope.setAddressesOnStepBack) {
                	$('.x-checkoutshippingaddress').get(0).set(true);
                	$('.x-checkoutbillingaddress').get(0).set(true);
                }

                $scope.StepNumber = 1;
                $scope.scrollTo({
                    el: $scope.ShippingAddress.Wrapper,
                    offset: $($scope.ShippingAddress.Wrapper).data('offset') || 0,
                    timeout: 200
                });
            };

            $scope.scrollToBillingAddress = function () {
                if ($scope.setAddressesOnStepBack) {
                	$('.x-checkoutshippingaddress').get(0).set(true);
                	$('.x-checkoutbillingaddress').get(0).set(true);
                }

                $scope.BillingAsShipping = false;
                $scope.StepNumber = 1;

                if (checkoutConfig.scrollToBillingAddressOnIsGift) {
                    $scope.scrollTo({
                        el: $scope.BillingAddress.Wrapper,
                        offset: $($scope.BillingAddress.Wrapper).data('offset') || 0,
                        timeout: 200
                    });
                }
            };

            $scope.scrollToBillingAddressTrue = function () {
            	$scope.BillingAsShipping = true;
            	$scope.StepNumber = 1;

            	$scope.scrollTo({
            		el: $scope.BillingAddress.Wrapper,
            		offset: $($scope.BillingAddress.Wrapper).data('offset') - 50 || 0,
            		timeout: 200
            	});
            };

            $scope.scrollToDeliveryPoint = function (onSite) {
                if (onSite) {
                    var $dpScope = angular.element('.x-control.x-angular-control.x-checkoutdeliverypoint').scope();
                    $dpScope.Model.Data.DeliveryPoints.forEach(function (dp) {
                        if (dp.Code.indexOf('onSite') > -1) {
                            $dpScope.Control.setSelectedDeliveryPoint(dp);
                        }
                    });
                }

                $scope.StepNumber = 1;
                $scope.scrollTo({
                    el: $scope.DeliveryPoint.Wrapper,
                    offset: $($scope.DeliveryPoint.Wrapper).data('offset') || 0,
                    timeout: 200
                });
            };

            $scope.scrollToTerms = function () {
                $scope.scrollTo({
                    el: $('*[data-wrapper="terms"]:first'),
                    offset: -20,
                    timeout: 200
                });
            };

            $scope.scrollTo = function (args) {
                if ($(args.el).length > 0) {
                    setTimeout(function () {
                        $('html, body').stop().animate({
                            scrollTop: $(args.el).offset().top + (args.offset || 0)
                        }, args.duration || 600, function () {
                            if (typeof (args.el.focus) == 'function')
                                args.el.focus();

                            if (typeof (args.onComplete) === 'function')
                                args.onComplete();
                        });
                    }, args.timeout || 0);
                }
            };

            $scope.newShippingAddress = function () {
                $scope.$broadcast('newShipping');
            };
            $scope.newBillingAddress = function () {
                $scope.$broadcast('newBilling');
            };
            $scope.setSelectedBillingAddress = function () {
                $('.x-checkoutorderreviewbox .angular-control-loading').removeClass('ng-hide').show();
                $scope.SelectedId = $('#select-billing').val();
                $scope.$broadcast('setSelectedBilling');
            };
            $scope.setSelectedShippingAddress = function () {
                $('.x-checkoutorderreviewbox .angular-control-loading').removeClass('ng-hide').show();
                $scope.SelectedId = $('#select-shipping').val();
                $scope.$broadcast('setSelectedShipping');
            };
            $scope.updateReviewBoxAddresses = function () {
                $scope.$broadcast('updateReviewBoxAddresses');
            };

            $scope.updateDisclaimer = function () {
                $scope.TermsAccepted = !$scope.TermsAccepted;
                if ($scope['Disclaimer1']) {
                    $scope['Disclaimer1'].Current.TermsAccepted = $scope.TermsAccepted;
                    $scope['Disclaimer1'].Current.TermsAcceptedError = !$scope.TermsAccepted;
                }
                if ($scope['Disclaimer2']) {
                    $scope['Disclaimer2'].Current.TermsAccepted = $scope.TermsAccepted;
                    $scope['Disclaimer2'].Current.TermsAcceptedError = !$scope.TermsAccepted;
                }
            }

            $scope.clearLocalCart = function () {
            	if (localStorage.getItem('CurrentCartModel') !== null) {
            		localStorage.removeItem('CurrentCartModel');
            	}
            };

            
            
            if (typeof checkoutConfig.InitFancybox === 'function' ){
                checkoutConfig.InitFancybox();
            }

        });

})();